import { Application } from "@hotwired/stimulus"

if (typeof global.Stimulus === "undefined") {
  global.Stimulus = Application.start()
}

export default global.Stimulus
